"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSlashedDateStrAbbr = exports.formatSlashedDateStr = exports.formatFullDateStr = void 0;
exports.formatFullDateStr = 'yyyy-MM-dd';
exports.formatSlashedDateStr = 'M/d/yy';
exports.formatSlashedDateStrAbbr = 'M/d';
exports.default = {
    formatFullDateStr: exports.formatFullDateStr,
    formatSlashedDateStr: exports.formatSlashedDateStr,
    formatSlashedDateStrAbbr: exports.formatSlashedDateStrAbbr,
};
//# sourceMappingURL=consts.js.map